import type { LaptopHelperStepProps } from '../Steps'

export const ExampleStep1 = ({}: LaptopHelperStepProps) => {
  return <div>Example Step 1</div>
}
